import { useMutation } from '@tanstack/react-query';
import { checkSSOAvailability } from '../../api/auth';
import { SSOAvailabilityResponse } from '../../api/types/sso.types';

export function useCheckSSOAvailabilityMutation() {
  return useMutation<SSOAvailabilityResponse, Error, string>({
    mutationFn: (email: string) => checkSSOAvailability(email),
  });
}
